import * as React from 'react';
import Icon from '@ant-design/icons';

const FieldInfoSvg = () => {
  return (
    <svg
      width={16}
      height={18}
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M10.5 4H13a1 1 0 011 1v10.5a1 1 0 01-1 1H3a1 1 0 01-1-1V5a1 1 0 011-1h2.5a2.5 2.5 0 015 0z"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 3.5A.25.25 0 118 4a.25.25 0 010-.5M4.5 8H8M10 8h1.5M11.5 10.5H8M6 10.5H4.5M4.5 13H8M10 13h1.5"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const FieldInfoIcon = (props: any) => (
  <Icon component={FieldInfoSvg} {...props} />
);

export default FieldInfoIcon;
